import { Control, Controller } from "react-hook-form";
import { Tool } from "./AssistantDetailsContent";
import { KnowledgeBasesField } from "./KnowledgeBasesField";
import { FlowsField } from "./FlowsField";
import { QuickActionField } from "./QuickActionField";
import { AgentsField } from "./AgentsField";
import { ActionsField } from "./ActionsField";
import { FFService } from "@/services/FeatureFlags/FeatureFlags";
import { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";

export const ConfigToolsField = ({
  name,
  control,
  quickTools,
  isNodeConfig,
  showSections = ["QuickAction", "Flows", "Knowledge", "Agents"],
  isDisabled,
  defaultValue,
  itemConfigByType,
}: {
  name: string;
  control: Control<any>;
  quickTools?: string[];
  isNodeConfig?: boolean;
  showSections?: string[];
  isDisabled?: boolean;
  defaultValue?: any;
  itemConfigByType?: Record<string, Record<string, NoxusFormEntryConfig>>;
}) => {
  const IS_ACTION_TOOLS_ENABLED = FFService.getVar(
    "COWORKER_ACTION_TOOLS_ENABLED"
  );

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const value = field.value as Tool[] | undefined;

        const sectionsToRender = showSections
          .map((section) => {
            if (section === "QuickAction") {
              return (
                <QuickActionField
                  key={section}
                  tools={value}
                  onToolsChange={field.onChange}
                  isNodeConfig={isNodeConfig}
                  isDisabled={isDisabled}
                />
              );
            } else if (section === "Knowledge") {
              return (
                <KnowledgeBasesField
                  key={section}
                  tools={value}
                  onToolsChange={field.onChange}
                  isNodeConfig={isNodeConfig}
                  isDisabled={isDisabled}
                  itemConfig={itemConfigByType?.["kb_qa"]}
                />
              );
            } else if (section === "Flows") {
              return (
                <FlowsField
                  key={section}
                  tools={value}
                  onToolsChange={field.onChange}
                  isNodeConfig={isNodeConfig}
                  isDisabled={isDisabled}
                  itemConfig={itemConfigByType?.["workflow"]}
                />
              );
            } else if (section === "Agents") {
              return (
                <AgentsField
                  key={section}
                  tools={value}
                  onToolsChange={field.onChange}
                  isNodeConfig={isNodeConfig}
                  isDisabled={isDisabled}
                  itemConfig={itemConfigByType?.["agent_tool"]}
                />
              );
            } else if (section === "Actions") {
              if (!IS_ACTION_TOOLS_ENABLED) {
                return null;
              }
              return (
                <ActionsField
                  key={section}
                  tools={value}
                  onToolsChange={field.onChange}
                  isNodeConfig={isNodeConfig}
                  isDisabled={isDisabled}
                />
              );
            }
            return null;
          })
          .filter(Boolean);

        return (
          <div className="flex flex-col gap-6 items-stretch w-full">
            {sectionsToRender}
          </div>
        );
      }}
    />
  );
};
